import * as axiosService from "./AxiosService";
import {getShopIdFromToken} from "../auth/authUtils";

export const getShop = async() => {
    try {
        const shopId = getShopIdFromToken();
        const response = await axiosService.getWithCredentialsSync(process.env.REACT_APP_API_SHOP_ROUTE + '/' + shopId)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateShop = async(shopData) => {
    try {
        const shopId = getShopIdFromToken();
        const response = await axiosService.putWithCredentialsSync(process.env.REACT_APP_API_SHOP_ROUTE + '/' + shopId , shopData);
        return response.data;
    } catch (error) {
        throw error;
    }
}
